import * as wjcCore from '@grapecity/wijmo';
import * as wjcGrid from '@grapecity/wijmo.grid';

'use strict';

import {ViewChild, Component, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";

import {ToasterService} from "angular2-toaster";

import {KaitoriyaConfig} from "../config/kaitoriya.config";
import {DataService, OrientDBCollectionView} from "@cosbeni/database";

@Component({
    selector: 'cj-admin-product',
    templateUrl: 'product-management.component.html',
})

export class ProductManagementComponent implements OnInit {
    readonly: Boolean = true;
    @ViewChild('productGrid') productGrid: wjcGrid.FlexGrid;
    products: OrientDBCollectionView;
    vertexes: any[] = [];

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService) {
        this.products = new OrientDBCollectionView(dataService, KaitoriyaConfig.DATABASE, "SELECT FROM AP_Product", "AP_Product", "", 0, 100, true, true, false)
        this.products.url = KaitoriyaConfig.SERVER_URL;
        this.products.tokenName = KaitoriyaConfig.DATABASE + "_token";
    }

    ngOnInit() {
        this.products.currentChanged.addHandler(this.onCurrentChanged, this);
        this.products.filterOnServer = true;
    }

    onCurrentChanged(sender: any, args: wjcCore.EventArgs): void {
    }

    refresh(grid: string): void {
        this[grid].invalidate();
    }

}

